export const GET_CONVERSION_DATA = 'conversion/GET_CONVERSION_DATA';
export const GET_CONVERSION_DATA_SUCCESS = 'conversion/GET_CONVERSION_DATA_SUCCESS';
export const GET_CONVERSION_DATA_FAIL = 'conversion/GET_CONVERSION_DATA_FAIL';

export const GET_CONVERSION_DRILL_DATA = 'conversion/GET_CONVERSION_DRILL_DATA';
export const GET_CONVERSION_DRILL_DATA_SUCCESS = 'conversion/GET_CONVERSION_DRILL_DATA_SUCCESS';
export const GET_CONVERSION_DRILL_DATA_FAIL = 'conversion/GET_CONVERSION_DRILL_DATA_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/conversion.js